import script from "./BaseHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseHeader.vue?vue&type=script&setup=true&lang=ts"

import "./BaseHeader.vue?vue&type=style&index=0&id=43cbe8f0&scoped=true&lang=less"
import "./BaseHeader.vue?vue&type=style&index=1&id=43cbe8f0&scoped=true&lang=less"

import exportComponent from "/Users/jizhengliang/Desktop/octopus/edu/educms-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43cbe8f0"]])

export default __exports__